import * as React from "react";
import {
  Column,
  Columns,
  Divider,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import GeneralTextField from "./GeneralTextField";
import { Field, useFormikContext } from "formik";
import ReadOnlyFieldWrapper from "../ReadOnlyFieldWrapper";
import { useAppContext } from "src/context/AppContext";
import { AccountPayer, FormValues } from "../types";

const FirstLastName = (props: { homeUser: boolean }) => {
  const { homeUser = false } = props;
  const { values } = useFormikContext<FormValues>();
  const {
    context: { user },
  } = useAppContext();
  const accountPayers = [
    values.electricityAccountPayer,
    values.gasLine?.accountPayer,
    values.gasMeter?.accountPayer,
    values.both?.accountPayer,
  ];
  const isReadOnly =
    homeUser &&
    values.accountHolder !== "company" &&
    !accountPayers.includes(AccountPayer.SOMEONE_ELSE);
  return (
    <Columns collapseBelow="md">
      <Column width="2/3">
        <Columns collapseBelow="md">
          <Column>
            {isReadOnly ? (
              <ReadOnlyFieldWrapper value={true}>
                <Stack space="xsmall">
                  <Stack space="xxsmall">
                    <Text variant="body-small" tone="neutralLight">
                      First Name
                    </Text>
                    <Text>{`${
                      values.accountPrimaryFirstName
                        ? values.accountPrimaryFirstName
                        : user?.first_name
                    }`}</Text>
                  </Stack>
                  <Divider />
                </Stack>
              </ReadOnlyFieldWrapper>
            ) : (
              <Field
                id="account-primary-first-name"
                name="accountPrimaryFirstName"
                label="First Name"
                component={GeneralTextField}
              />
            )}
          </Column>
          <Column>
            {isReadOnly ? (
              <ReadOnlyFieldWrapper value={true}>
                <Stack space="xsmall">
                  <Stack space="xxsmall">
                    <Text variant="body-small" tone="neutralLight">
                      Last Name
                    </Text>
                    <Text>{`${
                      values.accountPrimaryLastName
                        ? values.accountPrimaryLastName
                        : user?.last_name
                    }`}</Text>
                  </Stack>
                  <Divider />
                </Stack>
              </ReadOnlyFieldWrapper>
            ) : (
              <Field
                id="account-last-name"
                name="accountPrimaryLastName"
                label="Last Name"
                component={GeneralTextField}
              />
            )}
          </Column>
        </Columns>
      </Column>
      <Column width="1/3" />
    </Columns>
  );
};

export default FirstLastName;
